import React, { useState } from 'react';

const TeamModal = ({ users, onClose, onSave, teamToEdit }) => {
  const isEditMode = !!teamToEdit;
  const [team, setTeam] = useState(
    teamToEdit || {
      name: '',
      schedule: '',
      members: []
    }
  );

  const [newMember, setNewMember] = useState({
    userId: users[0]?.id || '',
    role: 'Asistente'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTeam(prev => ({ ...prev, [name]: value }));
  };

  const handleMemberChange = (e) => {
    const { name, value } = e.target;
    setNewMember(prev => ({ ...prev, [name]: value }));
  };

  const handleAddMember = () => {
    if (!newMember.userId) return;
    setTeam(prev => ({
      ...prev,
      members: [...prev.members, newMember]
    }));
    setNewMember({
      userId: users[0]?.id || '',
      role: 'Asistente'
    });
  };

  const handleRemoveMember = (index) => {
    setTeam(prev => ({
      ...prev,
      members: prev.members.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(team, isEditMode);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">{isEditMode ? 'Editar Equipo' : 'Nuevo Equipo'}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del Equipo</label>
              <input
                type="text"
                name="name"
                value={team.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Horario</label>
              <input
                type="text"
                name="schedule"
                value={team.schedule}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Agregar Miembro</label>
              <div className="flex space-x-2">
                <select
                  name="userId"
                  value={newMember.userId}
                  onChange={handleMemberChange}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
                >
                  {users.map(user => (
                    <option key={user.id} value={user.id}>{user.name}</option>
                  ))}
                </select>
                <select
                  name="role"
                  value={newMember.role}
                  onChange={handleMemberChange}
                  className="px-3 py-2 border border-gray-300 rounded-md"
                >
                  <option value="Asistente">Asistente</option>
                  <option value="Cuidador Principal">Cuidador Principal</option>
                </select>
                <button
                  type="button"
                  onClick={handleAddMember}
                  className="px-3 py-2 bg-cyan-600 text-white rounded-md hover:bg-cyan-700"
                >
                  +
                </button>
              </div>
            </div>

            <div className="mt-4">
              <h4 className="text-sm font-medium text-gray-700 mb-2">Miembros del Equipo</h4>
              {team.members.length > 0 ? (
                <div className="space-y-2">
                  {team.members.map((member, index) => {
                    const user = users.find(u => u.id === member.userId);
                    return (
                      <div key={index} className="flex items-center justify-between bg-gray-50 p-2 rounded">
                        <div>
                          <p className="font-medium">{user?.name}</p>
                          <p className="text-xs text-gray-500">{member.role}</p>
                        </div>
                        <button
                          type="button"
                          onClick={() => handleRemoveMember(index)}
                          className="text-red-500 hover:text-red-700"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-gray-500 text-sm">No hay miembros agregados</p>
              )}
            </div>
          </div>

          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700"
              disabled={team.members.length === 0}
            >
              {isEditMode ? 'Actualizar' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TeamModal;

// DONE